import { render } from "./DataSiniestro.vue?vue&type=template&id=3e395929&scoped=true"
import script from "./DataSiniestro.vue?vue&type=script&lang=js"
export * from "./DataSiniestro.vue?vue&type=script&lang=js"

import "./DataSiniestro.vue?vue&type=style&index=0&id=3e395929&lang=css"
import "./DataSiniestro.vue?vue&type=style&index=1&id=3e395929&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e395929"]])

export default __exports__